export default "__VITE_ASSET__BBByLVLs__"